import { useNavigate } from 'react-router-dom';

import { Grid } from '@mui/material';
import { useEffect } from 'react';
import * as routing from '../../constants/Routing';
import { useIsLogged } from '../../hooks/session/useIsLogged';
import { AuthBackground } from './components/AuthBackground';
import { AuthContentWrapper } from './components/AuthContentWrapper';
import { OTPForm } from './components/OTPForm';
import { OTPFormSelect } from './components/OTPFormSelect';
import { PhoneForm } from './components/PhoneForm';
import { Welcome } from './components/Welcome';
import { useAuth } from './hooks/useAuth';
import { useSessionLoginVerifyOtp } from './hooks/useSessionLoginVerifyOtp';
import { RegisterSoloDrivers } from './register';

export const AuthForm = () => {
  const { isLogged } = useIsLogged();
  const { isLoading, error: isError, run: verifyOtp } = useSessionLoginVerifyOtp();
  const { authScreen, registerData, setAuthScreen } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLogged && authScreen !== `register-data`) {
      navigate(routing.ROOT);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLogged]);

  return (
    <Grid container direction="column" wrap="nowrap" style={{ height: `100%` }}>
      <AuthBackground />

      {authScreen === `register-data` ? (
        <RegisterSoloDrivers />
      ) : (
        <AuthContentWrapper
          fullScreen={authScreen !== `login-welcome`}
          {...(authScreen !== `login-welcome`
            ? {
                onPreviousStep: () => {
                  switch (authScreen) {
                    case `login-phone`:
                      setAuthScreen(`login-select-method`);
                      break;
                    case `login-otp`:
                      setAuthScreen(`login-phone`);
                      break;
                    case `login-select-method`:
                      setAuthScreen(`login-welcome`);
                      break;
                    default:
                      break;
                  }
                },
              }
            : {})}
        >
          {authScreen === `login-welcome` && <Welcome />}
          {authScreen === `login-select-method` && <OTPFormSelect />}
          {authScreen === `login-phone` && <PhoneForm phone={registerData.phone} />}
          {authScreen === `login-otp` && (
            <OTPForm
              phone={registerData.phone!}
              isError={isError}
              isLoading={isLoading}
              validate={(otp) => verifyOtp({ otpCode: otp })}
            />
          )}
        </AuthContentWrapper>
      )}
    </Grid>
  );
};
